export const SUPERADMIN = "SUPERADMIN";
export const ADMIN = "ADMIN";
export const CITYADMIN = "CITYADMIN";
export const OCCURRENCESUBMIT = "OCCURRENCESUBMIT";
export const EDITOR = "EDITOR";
export const USER = "USER";
